<template>
    <div style="display: none;">
        <div class="book" style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">
            <div class="page" ref="dataprint" style="position: relative; width: 1000px; min-height: 1294px; margin: 0 auto;">
                <div
                    v-for="(page, indexPage) in pages"
                    :key="indexPage"
                    style="position: relative; width: 1000px; min-height: 1294px; background: white; margin: 0 auto; margin-bottom: 20px;"
                >
                    <div class="subpage" style="height: 1230px; padding-top: 20px; overflow: hidden;">
                        <div style="margin-left: 80px; margin-right: 50px;">
                            <div style="width: 100%;">
                                <table style="font-size: 12px; border-collapse: collapse; width: 100% !important;">
                                    <tr><td colspan="5" style="text-align: center;"><h2>DOCUMENTO TRIBUTARIO ELECTRÓNICO</h2></td></tr>
                                    <tr><td colspan="5" style="text-align: center;"><h1>COMPROBANTE DE LIQUIDACIÓN</h1></td></tr>
                                    <tr><td colspan="5"><hr /></td></tr>
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px; width: 20%;"><b>Código Generación:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 20%;">{{ dataProps.IdentificacionCodigoGeneracion }}</td>
                                        <td rowspan="3" style="padding: 0 10px 5px 10px; width: 20%;"><img ref="qrcode"/></td>
                                        <td style="padding: 0 10px 5px 10px; width: 20%;"><b>Modelo de facturación:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 20%;">
                                            {{ dataProps.IdentificacionTipoModelo == 1 ? "Previo" : "" }}
                                            {{ dataProps.IdentificacionTipoModelo == 2 ? "Diferido" : "" }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px;"><b>Número de Control:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ dataProps.IdentificacionNumeroControl }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Tipo de Transmisión:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ dataProps.IdentificacionTipoOperacion ? 'NORMAL' : 'CONTINGENCIA' }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px;"><b>Sello de recepción:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ dataProps.SelloRecibido }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Fecha y hora de generación:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ `${dataProps.IdentificacionFecEmi} ${dataProps.IdentificacionHorEmi}` }}</td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <div style="width: 100%;">
                                <table style="width: 100% !important; font-size: 11px; margin-top: 40px;">
                                    <div style="border-collapse: collapse; border: 1px solid black;">
                                        <tr>
                                            <td colspan="2" style="text-align: center;"><h2>COMISIONISTA (Emisor)</h2></td>
                                            <td colspan="2" style="text-align: center;"><h2>MANDANTE (Receptor)</h2></td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Nombre o Razón Social:</b></td>
                                            <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ dataProps.EmisorNombre }}</td>
                                            <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Nombre o Razón Social:</b></td>
                                            <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ dataProps.ReceptorNombre }}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 0 10px 5px 10px;"><b>Nombre comercial:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ dataProps.EmisorNombreComercial }}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 0 10px 5px 10px;"><b>NIT:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ applyNitMaskHandlingHomologationOutOfInput(dataProps.EmisorNit) }}</td>
                                            <td style="padding: 0 10px 5px 10px;"><b>NIT:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ applyNitMaskHandlingHomologationOutOfInput(dataProps.ReceptorNit) }}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 0 10px 5px 10px;"><b>NRC:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ applyDUIMaskOutOfInput(dataProps.EmisorNrc) }}</td>
                                            <td style="padding: 0 10px 5px 10px;"><b>NRC:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ applyDUIMaskOutOfInput(dataProps.ReceptorNrc) }}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 0 10px 5px 10px;"><b>Actividad Económica:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ dataProps.EmisorDescActividad }}</td>
                                            <td style="padding: 0 10px 5px 10px;"><b>Actividad Económica:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ dataProps.ReceptorDescActividad }}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 0 10px 5px 10px;"><b>Dirección:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ dataProps.EmisorDireccionComplemento }}</td>
                                            <td style="padding: 0 10px 5px 10px;"><b>Dirección:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ dataProps.ReceptorDireccionComplemento }}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 0 10px 5px 10px;"><b>Número de Teléfono:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ dataProps.EmisorTelefono }}</td>
                                            <td style="padding: 0 10px 5px 10px;"><b>Nombre Comercial:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ dataProps.ReceptorNombreComercial }}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 0 10px 5px 10px;"><b>Correo Electrónico:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ dataProps.EmisorCorreo }}</td>
                                            <td style="padding: 0 10px 5px 10px;"><b>Correo Electrónico:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">{{ dataProps.ReceptorCorreo }}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 0 10px 5px 10px;"><b>Tipo de Establecimiento:</b></td>
                                            <td style="padding: 0 10px 5px 10px;">
                                                {{ dataProps.EmisorTipoEstablecimiento === "01" ? "Sucursal Agencia" : "" }}
                                                {{ dataProps.EmisorTipoEstablecimiento === "02" ? "Casa Matriz" : "" }}
                                                {{ dataProps.EmisorTipoEstablecimiento === "04" ? "Bodega" : "" }}
                                                {{ dataProps.EmisorTipoEstablecimiento === "07" ? "Predio y/o patio" : "" }}
                                                {{ dataProps.EmisorTipoEstablecimiento === "20" ? "Otro" : "" }}
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </div>
                                </table>

                                <table style="width: 100% !important; font-size: 11px; margin-top: 40px; border-collapse: collapse;" border="1">
                                    <tr>
                                        <td style="padding: 5px;"><b>N.</b></td>
                                        <td style="padding: 5px; width: 60px;"><b>Tipo de Doc. Relacionado</b></td>
                                        <td style="padding: 5px;"><b>N. Doc. Relacionado</b></td>
                                        <td style="padding: 5px; width: 60px;"><b>Fecha</b></td>
                                        <td style="padding: 5px;"><b>Observación por ítem</b></td>
                                        <td style="padding: 5px; width: 65px;"><b>Exportaciones</b></td>
                                        <td style="padding: 5px; width: 65px;"><b>Ventas No Sujetas</b></td>
                                        <td style="padding: 5px; width: 65px;"><b>Ventas Exentas</b></td>
                                        <td style="padding: 5px; width: 65px;"><b>Ventas Gravadas</b></td>
                                    </tr>
                                    <tr v-for="(item, index) in valuesRows[indexPage]" :key="index">
                                        <td style="padding: 5px;">{{ index + 1 }}</td>
                                        <td style="padding: 5px;">{{ item.DTE_Type }}</td>
                                        <td style="padding: 5px;">{{ item.CodigoGeneracion }}</td>
                                        <td style="padding: 5px;">{{ item.InvoiceDateDF }}</td>
                                        <td style="padding: 5px;">{{ item.InvoiceInternalNote || '' }}</td>
                                        <td style="padding: 5px;">$ 0</td>
                                        <td style="padding: 5px;">$ {{ item.InvoiceTotalNoSuj }}</td>
                                        <td style="padding: 5px;">$ {{ item.InvoiceTotalExenta }}</td>
                                        <td style="padding: 5px;">$ {{ item.InvoiceTotalGravada }}</td>
                                    </tr>
                                </table>

                                <table v-if="indexPage == valuesRows.length - 1" style="width: 100% !important; font-size: 11px; border-collapse: collapse;" border="1">
                                    <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>Total Gravadas:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ dataProps.ResumenClTotalGravada }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>Total NoSuj:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ dataProps.ResumenClTotalNoSuj }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>Total Exenta:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ dataProps.ResumenClTotalExenta }}</td>
                                    </tr>
                                    <tr v-for="(value, index) in JSON.parse(dataProps.ResumenClTributos)" :key="index">
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>{{ value.descripcion }}:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ value.valor }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>Monto Total de la Operación:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ dataProps.ResumenClMontoTotalOperacion }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>IVA Percibido:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ dataProps.ResumenClIvaPerci }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>Total:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ dataProps.ResumenClTotal }}</td>
                                    </tr>
                                </table>

                                <table v-if="indexPage == valuesRows.length - 1" style="width: 100% !important; font-size: 11px; margin-top: 20px;">
                                    <div style="border-collapse: collapse; border: 1px solid black;">
                                        <tr>
                                            <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Valor en Letras:</b></td>
                                            <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ dataProps.ResumenClTotalLetras }}</td>
                                            <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Condición de la Operación:</b></td>
                                            <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">
                                                {{ dataProps.ResumenClCondicionOperacion == 1 ? "Contado" : "" }}
                                                {{ dataProps.ResumenClCondicionOperacion == 2 ? "A Crédito" : "" }}
                                                {{ dataProps.ResumenClCondicionOperacion == 3 ? "Otro" : "" }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 0 10px 5px 10px;"></td>
                                            <td style="padding: 0 10px 5px 10px;"></td>
                                            <td style="padding: 0 10px 5px 10px;"></td>
                                            <td style="padding: 0 10px 5px 10px;"></td>
                                        </tr>
                                    </div>
                                </table>

                                <table v-if="indexPage == valuesRows.length - 1" style="width: 100% !important; font-size: 11px; margin-top: 20px;">
                                    <div style="border-collapse: collapse; border: 1px solid black;">
                                        <tr>
                                            <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Responsable por parte del emisor:</b></td>
                                            <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ dataProps.ExtensionNombEntrega }}</td>
                                            <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Documento del responsable:</b></td>
                                            <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ dataProps.ExtensionDocuEntrega }}</td>
                                        </tr>
                                    </div>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import jsPDF from "jspdf";
import QRCode from 'qrcode';
import {
    applyDUIMaskOutOfInput,
    applyNitMaskHandlingHomologationOutOfInput
} from "../../helpers/masks";

export default {
    name: "PrintLiquidacionesClHidden",
    props: {
        dataProps: {
            type: Object,
            required: true,
        },
        invoices: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            numPages: 0,
            valuesRows: [],
        };
    },
    computed: {
        pages() {
            return Array.from({ length: this.numPages });
        },
    },
    methods: {
        applyDUIMaskOutOfInput(value) {
            return applyDUIMaskOutOfInput(value);
        },
        applyNitMaskHandlingHomologationOutOfInput(value) {
            return applyNitMaskHandlingHomologationOutOfInput(value);
        },
        calculatePagesOfDoc() {
            const invoices = Array.isArray(this.invoices) ? this.invoices : [];
            const rowsPerRegularPage = 18;
            const rowsOnLastPage = 10;

            this.valuesRows = [];

            if (!invoices.length) {
                this.valuesRows = [[]];
                this.numPages = 1;
                return;
            }

            if (invoices.length <= rowsOnLastPage) {
                this.valuesRows = [invoices];
                this.numPages = 1;
                return;
            }

            const fullRegularPages = Math.floor(invoices.length / rowsPerRegularPage);
            const remainingRows = invoices.length % rowsPerRegularPage;
            let cursor = 0;

            for (let pageIndex = 0; pageIndex < fullRegularPages; pageIndex++) {
                this.valuesRows.push(invoices.slice(cursor, cursor + rowsPerRegularPage));
                cursor += rowsPerRegularPage;
            }

            if (remainingRows === 0) {
                this.valuesRows.push([]);
            } else if (remainingRows <= rowsOnLastPage) {
                this.valuesRows.push(invoices.slice(cursor));
            } else {
                this.valuesRows.push(invoices.slice(cursor));
                this.valuesRows.push([]);
            }

            this.numPages = this.valuesRows.length;
        },
        async setupQr() {
            const { IdentificacionAmbiente, IdentificacionCodigoGeneracion, IdentificacionFecEmi } = this.dataProps;
            const url = `https://admin.factura.gob.sv/consultaPublica?ambiente=${IdentificacionAmbiente}&codGen=${IdentificacionCodigoGeneracion}&fechaEmi=${IdentificacionFecEmi}`;
            const opt = {
                errorCorrectionLevel: 'H',
                type: 'image/png',
                quality: 0.3,
                margin: 1,
                color: {
                    dark:"#000000",
                    light:"#ffffff"
                },
                width: 100
            };

            return new Promise((resolve, reject) => {
                QRCode.toDataURL(url, opt, (error, qrUrl) => {
                    if (error) {
                        reject(error);
                        return;
                    }

                    const qrRefs = Array.isArray(this.$refs.qrcode) ? this.$refs.qrcode : [this.$refs.qrcode];
                    qrRefs.filter(Boolean).forEach((ref) => {
                        ref.src = qrUrl;
                    });
                    resolve();
                });
            });
        },
        async buildPdfDocument() {
            const doc = new jsPDF('p', 'pt', 'letter');
            await doc.html(this.$refs.dataprint, {
                callback: function(generatedDoc) {
                    generatedDoc.output();
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas: {
                    scale: 0.612,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            });

            return doc;
        },
        getFilename() {
            const invoiceId = this.dataProps.ID_Invoice || 'comprobante';
            const numeroControl = String(this.dataProps.IdentificacionNumeroControl || '').replace(/[\\/:*?"<>|]/g, '');
            return `${invoiceId}_${numeroControl || this.dataProps.IdentificacionCodigoGeneracion}.pdf`;
        },
        async generatePdfBlob() {
            this.calculatePagesOfDoc();
            await this.$nextTick();
            await this.setupQr();
            await this.$nextTick();

            const doc = await this.buildPdfDocument();
            return {
                blob: doc.output('blob'),
                filename: this.getFilename(),
            };
        },
    }
}
</script>
